/// <reference path="highcharts/highcharts.js"/>
(function (hw) {
    hw.Helpers = (hw.Helpers || {});

    function parseTheme(obj, name) {
        // Parses chartOptions object to set control values
        // Used to choose a theme from saved themes
        for (var prop in obj) {
            var elem;
            switch (typeof obj[prop]) {
                case "object":
                    name.push(prop);
                    parseTheme(obj[prop], name);
                    break;
                case "string":
                    if (prop.toLowerCase().indexOf('color') > -1) {
                        // Color value so assume textbox for this in gui
                        elem = $('#chartstyle_' + name.join('_') + '_' + prop);
                        $(elem).css('background-color', obj[prop]);
                        $(elem).attr('title', obj[prop]);
                        if ($(elem).attr('title') == 'rgba(255,255,255,0)')
                            $(elem).css('background', 'url(\'images/transparent.png\') no-repeat center center');

                    } else {
                        // Most probably a select control
                        elem = $('#chartstyle_' + name.join('_') + '_' + prop);
                        $(elem).val(obj[prop]);
                    }
                    break;
                case "number":
                    // Could be a select, radio or checkbox maybe?
                    elem = $('#chartstyle_' + name.join('_') + '_' + prop);
                    $(elem).val(obj[prop]);
                    break;
            }
        }
        name.pop();
    }

    function applyChartStyles(styleArray, chartOptions) {
        // Parses and applies style array to chartOptions
        if (chartOptions) {
            $(styleArray).each(function (index) {

                //consider js bool coercion roles. we dont want to skip falsies
                if (typeof this.settingValue == 'undefined' || this.settingValue == null || (this.settingValue.length && this.settingValue.length == 0))
                    return;

                //convert string integers to numerics. types matters people!!!!!
                if (this.settingValue && this.settingValue.match && this.settingValue != '' && this.settingValue.match(/^[\d+-]*?$/))
                    this.settingValue = parseInt(this.settingValue, 10);

                //convert boolean string to actual booleans
                if (this.settingValue && this.settingValue.match && this.settingValue.match(/^(true|false)$/gi) != null)
                    this.settingValue = this.settingValue.toLowerCase() == 'true';

                //handle 'center' setting - convert to Array
                if (this.settingValue && this.settingKey.indexOf('pane_center') > -1) {
                    this.settingValue = this.settingValue.split(',');
                }

                if (this.settingKey.indexOf('yAxis') > -1 || this.settingKey.indexOf('xAxis') > -1) {
                    setupAxisSettings(this, chartOptions, styleArray);
                }
                else if (this.settingKey.indexOf('series_') > -1) {
                    setupSeriesSettings(this, chartOptions);
                } else {
                    this.settingKey = this.settingKey.replace(/_/g, '.');
                    if (this.settingKey.toLowerCase().indexOf('shadow') > -1)
                        setObjectPropertyValue(this.settingKey, chartOptions, (this.settingValue.toString().toLowerCase() == 'true'));
                    else
                        setObjectPropertyValue(this.settingKey, chartOptions, this.settingValue);
                }
            });
        }
    }

    function setObjectPropertyValue(path, opt, val) {
        var parts = path.split('.');
        var len = parts.length;
        for (var i = 0; i < len; i++) {
            opt[parts[i]] = (i == (len - 1) ? val : opt[parts[i]] || {});
            opt = opt[parts[i]];
        }
    }

    function findStyleByKey(key, styleArray) {
        for (var i = 0, style; (style = styleArray[i]); i++)
            if (style.settingKey == key)
                return style.settingValue;
        return null;
    }

    function setupAxisSettings(setting, chartOptions, styleArray) {
        if (!chartOptions.xAxis && !chartOptions.yAxis)
            return;

        // Setup axis work variables based on what axis the current setting is for
        var axisLength = (setting.settingKey.indexOf('yAxis') > -1) ? chartOptions.yAxis.length : chartOptions.xAxis.length;
        var axisLetter = (setting.settingKey.indexOf('yAxis') > -1) ? 'y' : 'x';
        var orgSettingKey = setting.settingKey;
        var seriesType = chartOptions.series.length > 0 ? chartOptions.series[0].type : chartOptions.chart.type;
        var inverted = chartOptions.chart.inverted;

        for (var i = 0; i < axisLength; i++) {

            var opposite = axisLetter == 'y' ? chartOptions.yAxis[i].opposite : chartOptions.xAxis[i].opposite;
            setting.settingKey = orgSettingKey.replace(axisLetter + 'Axis_', axisLetter + 'Axis_' + i + '_');
            setting.settingKey = setting.settingKey.replace(/_/g, '.');

            //controls axis label wrapping. three options: True, False and Fixed
            //True means "auto wrap", settings a max width of 90px to labels
            //False means "do nothing" and "Fixed" means reading a separate key and apply that to marginLeft or marginRight
            //depending on 'opposite' state
            var val;
            if (setting.settingKey.indexOf('.labels.style.width') > -1) {
                val = String(setting.settingValue).toLowerCase();

                if (val == 'fixed' && axisLetter == 'x') {
                    //first, apply the labels.style.width property with same value as the fixed wrapping width, minus a margin
                    //to avoid text spilling outside the chart
                    var wrappingWidth = parseInt(findStyleByKey('misc_fixedWrappingWidth', styleArray), 10);
                    if (isNaN(wrappingWidth))
                        continue;

                    setting.settingValue = wrappingWidth - 10;
                    setObjectPropertyValue(setting.settingKey, chartOptions, setting.settingValue);

                    //then change key to update marginRight or marginLeft with the fixed wrapping width
                    //legend.reversed - means that we have vertical chart here, so we need those margins
                    if (chartOptions.legend.reversed) {
                        setting.settingKey = opposite ? 'chart.marginRight' : 'chart.marginLeft';
                        setting.settingValue = parseInt(findStyleByKey('misc_fixedWrappingWidth', styleArray), 10);
                    }
                }
                else if (val == 'true' && !chartOptions.legend.reversed) { // only set for column-like, highcharts will handle bar-like
                    setting.settingValue = '90px';
                }
                else if (val == 'false') {
                    setting.settingKey = setting.settingKey.replace("width", "whiteSpace");
                    setting.settingValue = "nowrap";
                }
            }
            else if (setting.settingKey.indexOf('.misc.showLastLabel') > -1 && axisLetter == 'y') {
                //showLastLabel is a composite setting that sets four different settings on the chartOptions object
                val = String(setting.settingValue).toLowerCase() == 'true';
                setObjectPropertyValue(setting.settingKey.replace('misc.showLastLabel', 'startOnTick'), chartOptions, val);
                setObjectPropertyValue(setting.settingKey.replace('misc.showLastLabel', 'endOnTick'), chartOptions, true);
                setObjectPropertyValue(setting.settingKey.replace('misc.showLastLabel', 'showLastLabel'), chartOptions, val);
                setObjectPropertyValue(setting.settingKey.replace('misc.showLastLabel', 'showFirstLabel'), chartOptions, val);
            }

            // Insert current setting into chartOptions
            setObjectPropertyValue(setting.settingKey, chartOptions, setting.settingValue);

            // Below checks the current setting and see if it needs to add extra settings
            // like axis text offsets and alignment, etc...

            if (setting.settingKey.indexOf('.labels.rotation') > -1) {
                setupAxisLabelRotation(setting, seriesType, inverted, axisLetter, i, chartOptions);
            }
        }
        chartOptions.chart.marginBottom = null;  //clear margin that might be set in setDependentOptions
    }

    function setupSeriesSettings(setting, chartOptions) {
        var seriesLength = chartOptions.series.length;
        for (var i = 0; i < seriesLength; i++) {

            if (setting.settingKey == 'series_marker_enabled') {

                //property set from server takes precedence
                //if (chartOptions.series[i].marker && chartOptions.series[i].marker.enabled)
                //	setting.settingKey = 'dummy';
            }

            //scatter/bubble marker symbols are set on server side
            if (setting.settingKey == 'series_marker_symbol' && chartOptions.series[i].type == 'scatter')
                continue;

            if (setting.settingKey == 'series_dataLabels_verticalAlign' && chartOptions.series[i].type !== 'scatter' && chartOptions.series[i].type !== 'bubble')
                continue;

            var settingKey = setting.settingKey;
            settingKey = settingKey.replace('series_', 'series_' + i + '_');
            settingKey = settingKey.replace(/_/g, '.');
			var isStacked = (typeof chartOptions.series[i].stacking != 'undefined' && chartOptions.series[i].stacking != null);
			var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
			var ignoreStackedAlign = chartOptions.series[i].type == 'bar' || chartOptions.series[i].type == 'column' || !isChartCreator;
            if (settingKey.toLowerCase().indexOf('.shadow') > -1)
                setObjectPropertyValue(settingKey, chartOptions, (setting.settingValue.toString().toLowerCase() == 'true'));
			else if (isStacked == false || (isStacked == true && (!ignoreStackedAlign || settingKey.indexOf('.align') == -1)))
                setObjectPropertyValue(settingKey, chartOptions, setting.settingValue);
        }
    }

    function setupAxisLabelRotation(setting, seriesType, inverted, axisLetter, axisIndex, chartOptions) {
        var alignment = null;
        var xOffset, yOffset = 0;
        var margin;
        // REMEMBER! When using a bar chart, the axes are reversed (x is vertical, y is horizontal)
        switch (setting.settingValue) {
            case -90: // Vertical up
                alignment = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 'right' : 'center') : (axisLetter == 'y' ? 'center' : 'right');
                xOffset = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 2 : -4) : (axisLetter == 'y' ? -4 : 0);
                yOffset = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 5 : 0) : 0;
                // Move axis title 
                margin = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 20 : 30) : (axisLetter == 'y' ? 30 : 20);
                setObjectPropertyValue(axisLetter + 'Axis.' + axisIndex + '.title.margin', chartOptions, margin);
                break;
            case -45: // Diagonal up
                alignment = 'right';
                xOffset = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 4 : -2) : (axisLetter == 'y' ? -1 : 5);
                yOffset = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 8 : 0) : (axisLetter == 'y' ? 0 : 8);
                // Move axis title 
                setObjectPropertyValue(axisLetter + 'Axis.' + axisIndex + '.title.margin', chartOptions, 10);
                break;
            case 45: // Diagonal down
                alignment = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 'left' : 'right') : (axisLetter == 'y' ? 'right' : 'left');
                xOffset = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? -2 : -8) : (axisLetter == 'y' ? -5 : -5);
                yOffset = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 8 : 10) : (axisLetter == 'y' ? 5 : 8);
                // Move axis title 
                setObjectPropertyValue(axisLetter + 'Axis.' + axisIndex + '.title.margin', chartOptions, 10);
                break;
            case 90: // Vertical down
                alignment = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 'left' : 'center') : (axisLetter == 'y' ? 'center' : 'left');
                xOffset = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 0 : -10) : (axisLetter == 'y' ? -10 : 0);
                yOffset = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 5 : 0) : 0;
                // Move axis title 
                margin = (inverted || seriesType == 'bar') ? (axisLetter == 'y' ? 20 : 30) : (axisLetter == 'y' ? 30 : 20);
                setObjectPropertyValue(axisLetter + 'Axis.' + axisIndex + '.title.margin', chartOptions, margin);
                break;
            default:
                // Add axis title margin for horizontal labels
                margin = (inverted || seriesType == 'bar') ? 10 : (axisLetter == 'y' ? 20 : 10);
                setObjectPropertyValue(axisLetter + 'Axis.' + axisIndex + '.title.margin', chartOptions, margin);
                break;
        }

        if (Math.abs(setting.settingValue) > 0) {
            setObjectPropertyValue(axisLetter + 'Axis.' + axisIndex + '.labels.align', chartOptions, alignment);

            setObjectPropertyValue(axisLetter + 'Axis.' + axisIndex + '.labels.x', chartOptions, xOffset);

            if (yOffset != 0)
                setObjectPropertyValue(axisLetter + 'Axis.' + axisIndex + '.labels.y', chartOptions, yOffset);
        }
    }

    function fixLabels(chart, invertChart, dgVersion) {
        // solid gauge with several series and labels enabled
        if (chart.series.length > 1 && chart.series[0].type == "solidgauge" && chart.series[0].options.dataLabels.enabled) {
            fixSolidGaugeLabels(chart);
            return;
		}

		// donut with labels placed inside sectors - center them
        if (chart.series.length > 0 && chart.series[0].type === "pie" && chart.series[0].userOptions.dataLabels.distance && 
			chart.series[0].options.relativeSize.innerSize > 0 && chart.series[0].options.dataLabels.enabled) {
			fixDonutLabels(chart);
            setChartLabelVisibility(chart);
			return;
        }

        if (chart.series.length > 0 && chart.series[0].type === "pie" && chart.series[0].userOptions.dataLabels.distance &&
            chart.series[0].options.dataLabels.enabled) {
            setChartLabelVisibility(chart);
            return;
        }

        var align, type, isStacked, series, point, pShapeArgs, lShapeArgs;
        var transX, transY, targetX, targetY, margin = 0, hideDataPoint;

        for (var index = 0; index < chart.series.length; index++) {
            series = chart.series[index];
            isStacked = !!series.options.stacking;
            type = series.type.toLowerCase();
            var labelAlign = series.options.dataLabels.align || "top";
            align = isStacked ? 'center' : labelAlign.toLowerCase();

            for (var pIx = 0; pIx < series.data.length; pIx++) {
                hideDataPoint = false;
                point = series.data[pIx];

                if (!point || !point.dataLabel) continue;     /* nothing to see here, move on! */
                pShapeArgs = point.shapeArgs;
                lShapeArgs = point.dataLabel.getBBox();

                /* highcharts for some reason gives elements with 0 the full height of the bar instead of 0
				which makes them appear at odd places. Let's hide it! */
                hideDataPoint |= point.y == null || (point.y == 0 && align != 'right');

                if (type == 'column') {
                    targetX = pShapeArgs.x + (pShapeArgs.width / 2) - (lShapeArgs.width / 2);

                    /* hide datapoint if the label can't fit inside the element, unless it's right aligned and will be drawn outside */
                    hideDataPoint |= pShapeArgs.height <= lShapeArgs.height && align != 'right';

                    if (hideDataPoint)
                        point.dataLabel.hide();
                    else if (align == 'center')
                        targetY = (pShapeArgs.height / 2) - (lShapeArgs.height / 2) + pShapeArgs.y;
                    else if (align == 'left')
                        targetY = pShapeArgs.y + pShapeArgs.height - lShapeArgs.height;
                    else if (align == 'right')
                        targetY = pShapeArgs.y - lShapeArgs.height;

                    //Calculations for columns with negative values
                    if (point.y < 0) {
                        if (align == 'left')
                            targetY = pShapeArgs.y;
                        else if (align == 'right')
                            targetY = pShapeArgs.y + pShapeArgs.height;
                    }
                } else if (type == 'columnrange') {
                    // used by funnel chart. Has two labels - low and high, we need to keep just one and center it inside the bar
                    if (point.dataLabelUpper)
                        point.dataLabelUpper.hide();

                    var normX = chart.plotHeight - pShapeArgs.x - pShapeArgs.width;
                    var bottomOffs = chart.plotWidth - pShapeArgs.height - pShapeArgs.y;
                    /* bar is reversed, x is y */
                    targetY = normX + (pShapeArgs.width / 2) - (lShapeArgs.height / 2);
                    targetX = bottomOffs + (pShapeArgs.height / 2) - (lShapeArgs.width / 2);
                } else if (type == 'bar') {
                    /* hide datapoint if the label can't fit inside the element, unless it's right aligned and will be drawn outside */
                    hideDataPoint |= pShapeArgs.height <= lShapeArgs.width && align != 'right';
                    
                    if (hideDataPoint)
                        point.dataLabel.hide();

                    if (invertChart && dgVersion >= 12)
                        continue;

                    var normX = chart.plotHeight - pShapeArgs.x - pShapeArgs.width;
                    var bottomOffs = chart.plotWidth - pShapeArgs.height - pShapeArgs.y;
                    /* bar is reversed, x is y */
                    targetY = normX + (pShapeArgs.width / 2) - (lShapeArgs.height / 2);

                    if (!hideDataPoint) {
                        if (align == 'center')
                            targetX = bottomOffs + (pShapeArgs.height / 2) - (lShapeArgs.width / 2);
                        else if (align == 'left')
                            targetX = bottomOffs + margin;
                        else if (align == 'right')
                            targetX = bottomOffs + pShapeArgs.height + margin;
                    }

                    //Calculations for bars with negative values
                    if (point.y < 0) {
                        if (align == 'left')
                            targetX = bottomOffs + pShapeArgs.height - margin - lShapeArgs.width;
                        else if (align == 'right')
                            targetX = bottomOffs - lShapeArgs.width;
                    }
                } else if (type == 'scatter') {
                    pShapeArgs = point.graphic;
                    var valign = (series.options.dataLabels.verticalAlign || 'middle').toLowerCase();
                    var padding = series.options.dataLabels.padding;
                    if (pShapeArgs) {
                        // left places label to the right of marker, right - to the left (because highcharts does)
                        if (align == 'center')
                            targetX = Math.ceil(pShapeArgs.x + pShapeArgs.r - (lShapeArgs.width / 2));
                        else if (align == 'left')
                            targetX = pShapeArgs.x + pShapeArgs.r * 2;
                        else if (align == 'right')
                            targetX = pShapeArgs.x - lShapeArgs.width;

                        // top places label below marker, bottom - above (because highcharts does)
                        if (valign == 'middle')
                            targetY = Math.floor(pShapeArgs.y + pShapeArgs.r - (lShapeArgs.height / 2));
                        else if (valign == 'top')
                            targetY = pShapeArgs.y + pShapeArgs.r * 2 - lShapeArgs.height - lShapeArgs.y + padding;
                        else if (valign == 'bottom')
                            targetY = pShapeArgs.y - lShapeArgs.height;
                    }
                } else {
                    continue;
                }

                transX = targetX;
                transY = targetY;

                point.dataLabel.translate(transX, transY);
            }
        }
    }

    function setChartLabelVisibility(chart) {
        for (var index = 0; index < chart.series.length; index++) {
            var series = chart.series[index];
            for (var pIx = 0; pIx < series.data.length; pIx++) {
                var point = series.data[pIx];
                var pShapeArgs = point.shapeArgs;
                var lShapeArgs = point.dataLabel.getBBox();

                var angleSpan = Math.abs(pShapeArgs.end - pShapeArgs.start);
                var labelDistance = Math.sqrt(lShapeArgs.y ** 2 + lShapeArgs.x ** 2)

                if (labelDistance + lShapeArgs.width / 2 > pShapeArgs.r || lShapeArgs.width > angleSpan * pShapeArgs.r)
                    point.dataLabel.hide();
            }
        }
    }

	function centerLabelInSector(point, paneCenterX, paneCenterY, startAngle) {
		var lShapeArgs = point.dataLabel.getBBox();

		// all angles are in radians
		var endAngle = point.shapeArgs.end;

		// we want the label in the center of the gauge sector
		var medianR = point.shapeArgs.innerR + (point.shapeArgs.r - point.shapeArgs.innerR) / 2;
		var medianAngle = startAngle + ((endAngle - startAngle) / 2);

		// depending on angle we'll get positive or negative value, so it'll take care of left/right or top/bottom question
		var medianX = medianR * Math.cos(medianAngle);
		var medianY = medianR * Math.sin(medianAngle);

		point.dataLabel.translate(paneCenterX + medianX - (lShapeArgs.width / 2), paneCenterY + medianY - (lShapeArgs.height / 2));
	}

	function fixDonutLabels(chart) {
		var paneCenterX = chart.plotWidth / 2;
		var paneCenterY = chart.plotHeight / 2;

		for (var i = chart.series.length - 1; i >= 0; i--) {
			for (var p = 0; p < chart.series[i].points.length; p++) {
				var point = chart.series[i].points[p];
				centerLabelInSector(point, paneCenterX, paneCenterY, point.shapeArgs.start);
			}
		}
	}

    function fixSolidGaugeLabels(chart) {
        // gauge center position
        var paneCenterX = chart.panes[0].center[0];
        var paneCenterY = chart.panes[0].center[1];

        for (var i = chart.series.length - 1; i >= 0; i--) {
            var point = chart.series[i].points[0];
            // shapeArgs.start always points to the start of axis. so start angle for some series (all but last) is the end from another
            var startAngle = i == chart.series.length - 1 ? point.shapeArgs.start : chart.series[i + 1].points[0].shapeArgs.end;
			centerLabelInSector(point, paneCenterX, paneCenterY, startAngle);
        }
    }

    function fixLegendMarkerRadius(chart) {
        if (chart.series.length > 0) {
            $(chart.series).each(function () {
                if ((this.type === "line" || this.type === "spline" || this.type === "area") && this.legendSymbol && this.userOptions.marker.radius != 4) {
                    this.legendSymbol.translate(this.legendSymbol.width / 2 - 4, this.legendSymbol.height / 2 - 4);
                    this.legendSymbol.attr('width', 8);
                    this.legendSymbol.attr('height', 8);
                }
            });
        }
    }

	function fixHeaderFooter(chartDiv) {
		// TFS 9329
		var leDiv = chartDiv.closest('.layoutElement');
		if (/Firefox/.test(navigator.userAgent) && $('.layoutElementTitle', leDiv).length > 0 &&
			window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
			$('.layoutElementChart', leDiv).css('background-color', $('.highcharts-background', chartDiv).attr('fill'));
		}
	}

    function chartCreationComplete(chart, invertChart, dgVersion) {
        if (chart.series.length > 0 && (chart.series[0].type == "gauge" || chart.series[0].type == "solidgauge")) {
            // for gauge chart set extremes explicitly, otherwise hiding series will make ticks dissapear
            var extremes = chart.yAxis[0].getExtremes();
            chart.yAxis[0].setExtremes(extremes.min, extremes.max);
        }

		fixLegendMarkerRadius(chart);
		if(!chart.polar)
			fixLabels(chart, invertChart, dgVersion);
        addWarningTexts(chart);
        redrawColorQuadrants(chart);
    }

    function redrawColorQuadrants(chart) {
        $(chart.renderTo).find('rect[meanQuadrantRect="true"]').remove();
        if (chart.options.colorQuadrants) {
            var leftX = chart.plotBox.x,
                middleX = chart.xAxis[0].toPixels(chart.options.colorQuadrants.x),
                rightX = chart.plotBox.x + chart.plotBox.width;
            var topY = chart.plotBox.y,
                middleY = chart.yAxis[0].toPixels(chart.options.colorQuadrants.y),
                bottomY = chart.plotBox.y + chart.plotBox.height;

            chart.renderer.rect(leftX, topY, middleX - leftX, middleY - topY, 1)
                .attr({ fill: chart.options.colorQuadrants.topLeftColor, zIndex: 0, meanQuadrantRect: 'true' }).add();

            chart.renderer.rect(middleX, topY, rightX - middleX, middleY - topY, 1)
                .attr({ fill: chart.options.colorQuadrants.topRightColor, zIndex: 0, meanQuadrantRect: 'true' }).add();

            chart.renderer.rect(leftX, middleY, middleX - leftX, bottomY - middleY, 1)
                .attr({ fill: chart.options.colorQuadrants.bottomLeftColor, zIndex: 0, meanQuadrantRect: 'true' }).add();

            chart.renderer.rect(middleX, middleY, rightX - middleX, bottomY - middleY, 1)
                .attr({ fill: chart.options.colorQuadrants.bottomRightColor, zIndex: 0, meanQuadrantRect: 'true' }).add();
		}
	}

    function addWarningTexts(chart) {
        if (chart.options.warning.warningTexts.length > 0) {
            var warningTextArr = chart.options.warning.warningTexts;
            var paddingRight = 20;

            if (warningTextArr.length > 0) {
                var spacing = (window.ContentType === 3 ? 30 : 17); //To keep original position - 30 for CC, 17 for ST
                var ypos = (chart.chartHeight - spacing) + chart.options.warning.y;
                var xpos = chart.chartWidth - 100;
                var warningText = warningTextArr.join(', ');

                if (!chart.options.warning.style) //Set default style if it's missing
                    chart.options.warning.style = window.ContentType === 3 ? { fontSize: '12px', color: 'rgb(0, 0, 0)' } : { fontSize: '9px', color: 'rgb(0, 0, 0)' };
                chart.options.warning.style.fontWeight = (window.ContentType === 3 ? 'bold' : '');

                if (chart.options.title.text)
                    chart.options.warning.style.width = chart.chartWidth - chart.options.title.width - paddingRight;
                else
                    chart.options.warning.style.width = chart.chartWidth - paddingRight;

                var warningElem = chart.renderer.text(warningText, xpos, ypos).css(chart.options.warning.style).add();

                xpos = chart.chartWidth - warningElem.getBBox().width;
                warningElem.attr('x', xpos - paddingRight);
            }
        }
    }

    function getTheme(layoutElement, callback) {
        ChartSetupProxy.GetChartStyles(layoutElement, callback);
    }

    function setTheme(styles, layoutElement) {
        var data = { StyleGroup: { ChartStyles: styles, layoutElement: layoutElement} };
        Helpers.performJSonCall("RHViewStoryboard.aspx/SaveChartStyles", data, null, themeSaveFailed, true);
    }

    function themeSaveFailed(errorMessage) {
        Storyboard.LayoutControls.showMessage(errorMessage);
        setTimeout("$('#MessagePopup').fadeOut('fast')", 2000);
    }

    function removeEmptyFields(obj) {
        Object.keys(obj).forEach(function (key) {
            if (obj[key] && typeof obj[key] === 'object') removeEmptyFields(obj[key]);
            else if (obj[key] == null) delete obj[key];
        });
    }

    function overrideChartSpecificStyles(stylesToApply, chartOptions) {
        var chartSpecificStyles = []

        if (chartOptions.series && chartOptions.series.length > 0) {
            if (chartOptions.series[0].type === 'heatmap') {
                chartSpecificStyles = [
                    { settingKey: "series_dataLabels_align", settingValue: "center" }
                ];
            }
        }

        // merge chart specific styles
        chartSpecificStyles.forEach(function (style) {
            var st = stylesToApply.filter(function (sta) { return sta.settingKey === style.settingKey; })[0];

            if (st) st.settingValue = style.settingValue;
        });
    }

    hw.Helpers.getTheme = getTheme;
    hw.Helpers.setTheme = setTheme;
    hw.Helpers.parseTheme = parseTheme;
    hw.Helpers.applyChartStyles = applyChartStyles;
    hw.Helpers.setObjectPropertyValue = setObjectPropertyValue;
    hw.Helpers.chartCreationComplete = chartCreationComplete;
    hw.Helpers.themeSaveFailed = themeSaveFailed;
    hw.Helpers.fixLabels = fixLabels;
    hw.Helpers.redrawColorQuadrants = redrawColorQuadrants;
	hw.Helpers.fixHeaderFooter = fixHeaderFooter;
    hw.Helpers.removeEmptyFields = removeEmptyFields;
    hw.Helpers.overrideChartSpecificStyles = overrideChartSpecificStyles;

})(window.Storyboard.HighchartsWrapper = (window.Storyboard.HighchartsWrapper || {}));
